import { useState } from 'react';
import FilterIcon from '@root/lib/components/Icons/Filters';
import Close from '@root/lib/components/Icons/Close';
import cn from 'classnames';
import './Controls.scss';

const Controls = ({
  filters,
  className,
  activeFilters,
  renderFilters,
  onChange,
}) => {
  const [ open, setOpen ] = useState(false);

  return (
    <div className={cn('MealSelectionGridControls', className)}>
      <div className="MealSelectionGridControls__Group">
        {activeFilters.length > 0 && (
          <button className="MealSelectionGridControls__ClearFilters" onClick={() => onChange([])}>Clear All</button>
        )}
        <button className="MealSelectionGridControls__FiltersButton" onClick={() => setOpen(f => !f)}>
          {open ? (
            <>
              <Close stroke="#3A3B35" /> Close
            </>
          ) : (
            <>
              <FilterIcon /> Filters {activeFilters.length > 0 && `(${activeFilters.length})`}
            </>
          )}
        </button>
      </div>
      <div className={cn({
        'MealSelectionGridControls__Filters': true,
        'MealSelectionGridControls__Filters--open': open,
        'MealSelectionGridControls__Filters--closed': !open,
      })}>
        {renderFilters(open)}
      </div>
    </div>
  );
}

export default Controls;